import { fetch } from '@utils/utils';

export const getEmployeeRole = () => async id => {
  try {
    const response: any = await fetch(`/metropolis/api/users/${id}/roles`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json = await response.json();

    return {
      employeeId: id,
      roleId: json.length === 1 ? json[0].id : null
    };
  } catch (err) {
    return { employeeId: { id } };
  }
};

export const getAllAssignedRoles = async () => {
  try {
    const response: any = await fetch(`/metropolis/api/users/roles`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json = await response.json();

    return json;
  } catch (err) {
    return [];
  }
};

export const pushEmployeeRole = async ({ employeeId, roleId }) => {
  const body = roleId ? [{ id: roleId }] : [];
  try {
    const response: any = await fetch(`/metropolis/api/users/${employeeId}/roles`, {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body)
    });

    return response.ok;
  } catch (err) {
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/modules/roles-assing/_rolesAssignActions.ts